// services/jurnalMingguanService.js
import axios from "axios";
import { downloadFilename } from './downloadFilename';
import { ApiConfig } from "../constants/apiConfig";
import { studentAuthorizationHeaders } from './authService';

export const fetchJurnalMingguan = async (siswaId, page = 1, perPage = 2) => {
  try {
    const response = await axios.get(`${ApiConfig.baseUrl}/jurnal-mingguan`, {
      params: {
        siswa_id: siswaId,
        page: page,
        per_page: perPage,
      },
      headers: studentAuthorizationHeaders(),
    });

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        message: response.data.message || "Gagal mengambil data jurnal mingguan",
      };
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat mengambil data jurnal mingguan",
    };
  }
};

export const downloadJurnalMingguanPDF = async (siswaId, mingguKe) => {
  try {
    const response = await fetch(
      `${ApiConfig.baseUrl}/export/jurnal-mingguan/download?siswa_id=${siswaId}&minggu_ke=${mingguKe}`,
      {
        headers: studentAuthorizationHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error("Gagal mendownload file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", downloadFilename(response.headers.get('content-disposition'), `Jurnal_Mingguan_Minggu_${mingguKe}.pdf`));
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true };
  } catch (error) {
    console.error("Download error:", error);
    return {
      success: false,
      message: "Terjadi kesalahan saat mendownload file.",
    };
  }
};
export const ajukanJurnalMingguan = async (formData) => {
  try {
    const response = await axios.post(
      `${ApiConfig.baseUrl}/jurnal-mingguan`,
      formData,
      {
        headers: studentAuthorizationHeaders(),
      }
    );

    return response.data.success
      ? { success: true }
      : { success: false, message: response.data.message };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Terjadi kesalahan saat mengirim data jurnal.",
    };
  }
};

export const updateJurnalMingguan = async (id, formData) => {
  try {
    formData.append('_method', 'PUT');
    const response = await axios.post(
      `${ApiConfig.baseUrl}/jurnal-mingguan/${id}`,
      formData,
      { headers: studentAuthorizationHeaders() }
    );
    return response.data?.success
      ? { success: true, message: response.data.message || 'Jurnal diperbarui.' }
      : { success: false, message: response.data?.message || 'Gagal memperbarui jurnal.' };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || error.message || 'Gagal memperbarui jurnal mingguan.' };
  }
};

export const hapusJurnalMingguan = async (id) => {
  try {
    const response = await axios.delete(`${ApiConfig.baseUrl}/jurnal-mingguan/${id}`, {
      headers: studentAuthorizationHeaders(),
    });
    return { success: response.data?.success === true, message: response.data?.message || 'Jurnal dihapus.' };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || error.message || 'Gagal menghapus jurnal mingguan.' };
  }
};
